export class AppProperties {
    public static readonly PROJECT_READ = 'PROJECT_READ';
    public static readonly CHARGE_ACCOUNT_READ = 'CHARGE_ACCOUNT_READ';
    public static readonly COST_CENTER_READ = 'COST_CENTER_READ';
    public static readonly PEOPLE_READ = 'PEOPLE_READ';
    public static readonly PEOPLE_VIEW = 'PEOPLE_VIEW';
    public static readonly PEOPLE_UPDATE = 'PEOPLE_UPDATE';
    public static readonly ADM_AND_FIN_LIQUIDATION = 'ADM_&_FIN_LIQUIDATION';

    public static readonly CONTRIBUTOR_VIEW = 'CONTRIBUTOR_VIEW';

    // Roles de aprobación de solicitudes de vacaciones
    public static readonly PROJECT_LEAD_APPROVER = 'PROJECT_LEAD_APPROVER';
    public static readonly HR_APPROVER = 'HR_APPROVER';

    // Roles de administración
    public static readonly USER_CREATE = 'USER_CREATE';
    public static readonly PROFILE_CREATE = 'PROFILE_CREATE';
    public static readonly ROLE_CREATE = 'ROLE_CREATE';
    public static readonly TIMESHEET_MANAGER = 'TIMESHEET_MANAGER';

    public static readonly VACATION_CREATE = 'VACATION_CREATE';
    public static readonly VACATION_HISTORY_READ = 'VACATION_HISTORY_READ';
    public static readonly PAYROLL_STATEMENT_READ = 'PAYROLL_STATEMENT_READ';
    public static readonly TIMESHEET_CREATE = 'TIMESHEET_CREATE';

    public static readonly MIGRATOR = 'MIGRATOR';

    // Roles de gestión de clientes
    public static readonly CLIENT_READ = 'CLIENT_READ';
    public static readonly CLIENT_CREATE = 'CLIENT_CREATE';
    public static readonly CLIENT_UPDATE = 'CLIENT_UPDATE';
    public static readonly CLIENT_DELETE = 'CLIENT_DELETE';

    // Roles de gestión de países
    public static readonly COUNTRY_READ = 'COUNTRY_READ';
    public static readonly COUNTRY_WRITE = 'COUNTRY_WRITE';

    // Roles de gestión de parámetros generales
    public static readonly PARAM_READ = 'PARAM_READ';
    public static readonly PARAM_WRITE = 'PARAM_WRITE';

    // Roles de gestión de API Keys
    public static readonly API_MANAGE = 'API_MANAGE';

    // Roles de gestión de subcontratos
    public static readonly SUBCONTRACT_READ = 'SUBCONTRACT_READ';
    public static readonly SUBCONTRACT_WRITE = 'SUBCONTRACT_WRITE';
    public static readonly SUBCONTRACT_APPROVE = 'SUBCONTRACT_APPROVE'; // legacy
    public static readonly SUBCONTRACT_APPROVE_LEADER = 'SUBCONTRACT_APPROVE_LEADER';
    public static readonly SUBCONTRACT_APPROVE_FINANZAS = 'SUBCONTRACT_APPROVE_FINANZAS';

    // Rol portal subcontratista
    public static readonly CONTRIBUTOR_VIEW_SUBCONTRATO = 'CONTRIBUTOR_VIEW_SUBCONTRATO';

    // Roles de facturación
    public static readonly FACTURACION_READ = 'FACTURACION_READ';
    public static readonly FACTURACION_WRITE = 'FACTURACION_WRITE';

    // Roles de gestión de candidatos
    public static readonly CANDIDATE_READ = 'CANDIDATE_READ';
    public static readonly CANDIDATE_CREATE = 'CANDIDATE_CREATE';
    public static readonly CANDIDATE_UPDATE = 'CANDIDATE_UPDATE';
    public static readonly CANDIDATE_DELETE = 'CANDIDATE_DELETE';

    // Roles de gestión de compañías
    public static readonly COMPANY_READ = 'COMPANY_READ';
    public static readonly COMPANY_CREATE = 'COMPANY_CREATE';
    public static readonly COMPANY_UPDATE = 'COMPANY_UPDATE';
    public static readonly COMPANY_DELETE = 'COMPANY_DELETE';

    // Roles de gestión de proyectos
    public static readonly PROJECT_CREATE = 'PROJECT_CREATE';
    public static readonly PROJECT_UPDATE = 'PROJECT_UPDATE';
    public static readonly PROJECT_DELETE = 'PROJECT_DELETE';
    public static readonly PRICING_APPROVE_LIDER = 'PRICING_APPROVE_LIDER';
    public static readonly PRICING_APPROVE_FINANZAS = 'PRICING_APPROVE_FINANZAS';

    // Roles de gestión de personas
    public static readonly PEOPLE_CREATE = 'PEOPLE_CREATE';
    public static readonly PEOPLE_DELETE = 'PEOPLE_DELETE';

    // Roles de gestión de centros de costos
    public static readonly COST_CENTER_CREATE = 'COST_CENTER_CREATE';
    public static readonly COST_CENTER_UPDATE = 'COST_CENTER_UPDATE';
    public static readonly COST_CENTER_DELETE = 'COST_CENTER_DELETE';

    // Roles de gestión de cuentas de cargo
    public static readonly CHARGE_ACCOUNT_CREATE = 'CHARGE_ACCOUNT_CREATE';
    public static readonly CHARGE_ACCOUNT_UPDATE = 'CHARGE_ACCOUNT_UPDATE';
    public static readonly CHARGE_ACCOUNT_DELETE = 'CHARGE_ACCOUNT_DELETE';

    // Roles de búsquedas / reclutamiento
    public static readonly SEARCH_READ = 'SEARCH_READ';
    public static readonly SEARCH_CREATE = 'SEARCH_CREATE';
    public static readonly SEARCH_UPDATE = 'SEARCH_UPDATE';
    public static readonly SEARCH_CLOSE = 'SEARCH_CLOSE';

    // Roles de gestión de feriados
    public static readonly HOLIDAY_READ = 'HOLIDAY_READ';
    public static readonly HOLIDAY_WRITE = 'HOLIDAY_WRITE';

    // Roles adicionales de parámetros generales
    public static readonly PARAM_DELETE = 'PARAM_DELETE';
}